/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Portals_Disable_ConfirmInputs */

const cs_portals_disable_confirm = /** @type {(inputs: Portals_Disable_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odebrat inzerát z ${i?.provider}?`)
};

const en_portals_disable_confirm = /** @type {(inputs: Portals_Disable_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove listing from ${i?.provider}?`)
};

/**
* | output |
* | --- |
* | "Remove listing from {provider}?" |
*
* @param {Portals_Disable_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_disable_confirm = /** @type {((inputs: Portals_Disable_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Disable_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_disable_confirm(inputs)
	return cs_portals_disable_confirm(inputs)
});